import apiClient from './api';
import type {
  WhatsappConnectionStatusResult,
  WhatsappMessage,
  ConnectWhatsappRequest,
  SendWhatsappMessageRequest,
} from '../types/whatsapp';

export const whatsappService = {
  getStatus: async (organisationId: number): Promise<WhatsappConnectionStatusResult> => {
    const { data } = await apiClient.get<WhatsappConnectionStatusResult>(
      `/organisations/${organisationId}/whatsapp/status`,
    );
    return data;
  },

  connect: async (organisationId: number, dto: ConnectWhatsappRequest) => {
    const { data } = await apiClient.post(`/organisations/${organisationId}/whatsapp/connect`, dto);
    return data;
  },

  disconnect: async (organisationId: number): Promise<void> => {
    await apiClient.delete(`/organisations/${organisationId}/whatsapp/disconnect`);
  },

  listMessages: async (leadId: number): Promise<WhatsappMessage[]> => {
    const { data } = await apiClient.get<WhatsappMessage[]>(`/crm/leads/${leadId}/whatsapp-messages`);
    return data;
  },

  sendMessage: async (leadId: number, dto: SendWhatsappMessageRequest): Promise<WhatsappMessage> => {
    const { data } = await apiClient.post<WhatsappMessage>(`/crm/leads/${leadId}/whatsapp-messages`, dto);
    return data;
  },
};
